import React from "react";
import "./index.css";

export default function Creatorplatformcontainer() {
  return (
    <div className="platform-container">
      <div className="left-platform-container">
        <h1>
          Get your podcast on <span> India's top </span> platforms
        </h1>
      </div>
      <div className="right-platform-container">
        <img
          alt="hubhopper"
          src="https://files.hubhopper.com/assets/web/2020-11-02/platforms.png?v=1.1"
        ></img>
      </div>
    </div>
  );
}
